<template>
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="升级记录" name="log"></el-tab-pane>
    </el-tabs>

    <!--会员升级记录-->
    <Log v-if="activeName == 'log'"></Log>
  </div>
</template>
<script>
import Log from './part/Log';
export default {
  components: {
    Log
  },
  data() {
    return {
      form: {
        status: 0
      },
      activeName: 'log'
    };
  },
  methods: {}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/user/grade/log.vue